import apiEndPoints from "../../utils/apiEndPoints";
import { apiCall } from "../../utils/httpClient";

const header = {
  "Content-Type": "application/x-www-form-urlencoded",
  //   "access-control-allow-origin": "*",
};

const getRaiseTicketList = async (params) => {
  const data = await apiCall("post", apiEndPoints.GETRAISETICKETLIST, params);
  return data;
};
const getRaiseTicketDetail = async (params) => {
  const data = await apiCall("post", apiEndPoints.RAISETICKETDETAILS, params);
  return data;
};
const ticketStatusUpdate = async (params) => {
  const data = await apiCall("post", apiEndPoints.TICKETSTATUSUPDATE, params);
  return data;
};
const updateRaiseTicket = async (params) => {
  const data = await apiCall(
    "post",
    apiEndPoints.UPDATESUPPORT,
    params,
    header
  );
  return data;
};
const replySupportTicket = async (params) => {
  const data = await apiCall("post", apiEndPoints.REPLYSUPPORTTICKET, params);
  return data;
};
const addRaiseTicket = async (params) => {
  const data = await apiCall(
    "post",
    apiEndPoints.ADDRAISETICKET,
    params,
    header
  );
  return data;
};
const raiseTicketSerive = {
  getRaiseTicketList,
  getRaiseTicketDetail,
  updateRaiseTicket,
  replySupportTicket,
  addRaiseTicket,
  ticketStatusUpdate,
};

export default raiseTicketSerive;
